module.exports = __webpack_public_path__ + "img/regist-pop-up.c0fef8e.png";